
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { Helmet } from 'react-helmet';

createRoot(document.getElementById("root")!).render(
  <>
    <Helmet>
      <link rel="sitemap" type="application/xml" href="/sitemap.xml" />
    </Helmet>
    <App />
  </>
);
